import TextableModel from '../TextableModel';
import { defaultDescriptors } from '../../utils/PropertyDescriptor';

export default class Model extends TextableModel {

    constructor(opts = {}) {
        super();
        // for (let field in defaultDescriptors.dataSource) {
        //     this[field] = defaultDescriptors.dataSource[field];
        // }
        this.defineAllProperties();

        this.backgroundColor = "transparent";
        this.borderWidth = 0;
        this.text = "文本框";
        this.width = 0;
        this.height = 0;
        this.padding = { top: 5, bottom: 5, left: 8, right: 8 };


        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "TextModel";
    }

    toString() {
        return this.text || super.toString();
    }
}
